<template>
    <div>

        <!-- Openstaande facturen -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-briefcase"></i>
            </h2>
            <div class="w-100">
                <h2 class="mb-1">
                    Openstaande facturen
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button"
                        data-bs-toggle="collapse" data-bs-target="#unpaidInvoices" aria-expanded="true"
                        aria-controls="unpaidInvoices">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="unpaidInvoices">

                <div class="messages">

                    <div class="message">
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">Meer dan 30 dagen</p>
                                <span class="date ms-sm-auto text-end">
                                    Aantal: {{ unpaidInvoices['30']?.invoiceNumber || 0 }}<br>
                                    <span class="fw-semibold" v-html="unpaidInvoices['30']?.priceTotal"></span>
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a href="order-invoice?filter=1&status=expired&expired_days=30" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>

                    <div class="message">
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">Meer dan 60 dagen</p>
                                <span class="date ms-sm-auto text-end">
                                    Aantal: {{ unpaidInvoices['60']?.invoiceNumber || 0 }}<br>
                                    <span class="fw-semibold" v-html="unpaidInvoices['60']?.priceTotal"></span>
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a href="order-invoice?filter=1&status=expired&expired_days=60" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>

                    <div class="message">
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">Meer dan 90 dagen</p>
                                <span class="date ms-sm-auto text-end">
                                    Aantal: {{ unpaidInvoices['90']?.invoiceNumber || 0 }}<br>
                                    <span class="fw-semibold" v-html="unpaidInvoices['90']?.priceTotal"></span>
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a href="order-invoice?filter=1&status=expired&expired_days=90" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>

                    <div class="message">
                        <div class="content hasBeenRead">
                            <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                <p class="sender">Meer dan 360 dagen</p>
                                <span class="date ms-sm-auto text-end">
                                    Aantal: {{ unpaidInvoices['360']?.invoiceNumber || 0 }}<br>
                                    <span class="fw-semibold" v-html="unpaidInvoices['360']?.priceTotal"></span>
                                </span>
                            </div>
                        </div>
                        <div class="actions">
                            <a href="order-invoice?filter=1&status=expired&expired_days=360" target="_blank">
                                <i class="fa fa-external-link"></i>
                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'unpaid-invoices',
    components: {},
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            unpaidInvoices: {
                '30': {
                    invoiceNumber: 0,
                    priceTotal: null,
                },
                '60': {
                    invoiceNumber: 0,
                    priceTotal: null,
                },
                '90': {
                    invoiceNumber: 0,
                    priceTotal: null,
                },
                '360': {
                    invoiceNumber: 0,
                    priceTotal: null,
                },
            },
            componentId: 'unpaid-invoices-component',
            componentIsVisable: this.isVisible,
            loading: true,
        }
    },
    computed: {},
    watch: {},
    methods: {
        updateComponentVisability(component_id) {
            // Toggle the visibility state
            this.componentIsVisable = !this.componentIsVisable;
            axios.get('api/update-component-visability', {
                params: {
                    component_id: component_id,
                    is_visable: this.componentIsVisable
                }
            });

            if (this.componentIsVisable) {
                this.loading = true;
                this.getUnpaidInvoices();
            }
        },
        getUnpaidInvoices() {
            axios.get('api/unpaid-invoices')
                .then(response => {
                    this.unpaidInvoices = response.data.unpaidInvoices;
                    this.loading = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
    },
    mounted() {
        if (this.isVisible) {
            this.getUnpaidInvoices();

        } else {
            this.loading = false;
        }
    },
    created() {
    },
}
</script>

<style scoped>
.padding-round {
    padding: 0 25px 0 25px;
}
</style>
